export default __webpack_public_path__ + "static/media/P348MANB6.328ca1fb.pdf";